<!--
 * @Author: your name
 * @Date: 2022-03-17 16:41:37
 * @LastEditTime: 2022-03-23 17:37:18
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\Login.vue
-->
<template>
  <div>
    <div class="Login-all">
<!--      <div class="Login-w">-->
        <div class="login-Imgs clearfix">
          <div class="login-Imgs-lfet">
            <img src="../../../assets/pc/pro/bg.png" alt="" />
          </div>
          <div class="login-Imgs-right">
            <div class="clearfix">
              <div class="login-Imgs-right-images">
                <img src="../../../assets/pc/intro/头像.png" alt="" />
              </div>
              <div class="login-Imgs-right-text">
                <p class="login-Imgs-right-p1">{{ $t("Login.bindWallet") }}</p>
                <p class="login-Imgs-right-p2">{{ $t("Login.Email") }}</p>
              </div>
            </div>
            <div class="login-input">
              <el-form
                      ref="ruleForm"
                      :model="ruleForm"
                      :rules="rules"
                      label-width="100px"
                      class="demo-ruleForm"
                      autocomplete="off"
              >
                <div v-if="active == 1">
                  <!-- wallet -->
                  <el-form-item prop="wallet">
                    <p>Your wallet address</p>
                    <el-input v-model="ruleForm.wallet" placeholder="Wallet address" />
                  </el-form-item>
                  <!-- to -->
                  <el-form-item prop="to">
                    <p>Transfer to the wallet address</p>
                    <el-input :disabled="true"
                            v-model="ruleForm.to"
                            value = ""
                    />
                  </el-form-item>
                  <!-- 邮箱 -->
                  <el-form-item prop="amount">
                    <el-input v-model="ruleForm.amount" :disabled="true"  maxlength="4" value = "" />
                    <el-button class="el-btn1">
                      The number of DO transferred
                    </el-button >
                    <span class="status">{{ statusMsg }}</span>
                  </el-form-item>

                  <el-form-item prop="hash">
                    <el-input v-model="ruleForm.hash" placeholder="Please enter a transaction hash" />
                  </el-form-item>
                  <p>Note: Wallet address cannot be changed after binding, please check carefully.</p>
                  <!-- 登录 -->
                  <el-form-item prop="Signup">
                    <el-button class="el-btn2" @click="bindWallet">{{$t("Login.Ok")}}</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>

  // import Canvas from "@/components/pc/canvas.vue";
  export default {
    data() {
      return {
        active: 1,
        statusMsg: "",
        ruleForm: {
          wallet: "",
          to: "1AxxxxxxxxxxxxxxxxxxxxxX2",
          amount: "0.243",
          hash: "",
        },
        rules: {
          wallet: [
            {
              required: true,
              type: "string",
              message: "Please enter bind wallet",
              trigger: "blur",
            },
          ],
          hash: [
            {
              required: true,
              message: "Please enter a transaction hash",
              trigger: "blur",
            },
          ],
        },
        formData: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        reg: "reg",
        cs: this.$route.params,
        Value: "",
      };
    },
    methods: {
      childByValue(childValue) {
        // childValue就是子组件传过来的值
        this.Value = childValue;
      },
      async bindWallet() {
        let wallet = this.ruleForm.wallet;
        let hash = this.ruleForm.hash;
        if (wallet != "") {
          if (hash != "") {
              let params = {
                loginName: wallet,
                password: hash,
              }
          }
        }
      },
    },
    // components: {
    //   Canvas,
    // },
  };
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .clearfix:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {
    *zoom: 1;
  }
  .Login-all {
    width: 100%;
    height: 100%;

  .el-input.is-disabled /deep/.el-input__inner {
    background-color: #ffffff !important;
    border-color: #E4E7ED !important;
    font-size: 14px;
    font-family: Poppins-Regular, Poppins;
    font-weight: 400;
    color: #4F5368;
    line-height: 16px;
    cursor: not-allowed;
  }

  .login-Imgs {
    /*margin-bottom: 331px;*/
    box-shadow: 0 4px 30px 1px rgba(0, 0, 0, 0.06);
  .login-Imgs-lfet {
    img {
      width: 780px;
      height: 614px;
      float: left;
    }
  }
  .login-Imgs-right {
    float: left;
    width: 410px;
    height: 614px;
    background-color: #fff;

    padding: 53px 30px 0 30px;
    box-sizing: border-box;
  .login-Imgs-right-images {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #e3eafb;
    float: left;
    margin-right: 25px;
  }
  .login-Imgs-right-text {
    float: left;
  .login-Imgs-right-p1 {
    font-size: 24px;
    font-weight: 600;
    color: #2c1d1a;
    line-height: 41px;
    font-family: Poppins-SemiBold, Poppins;
    -webkit-background-clip: text;
    margin: 0;
  }
  .login-Imgs-right-p2 {
    font-size: 14px;
    font-weight: 400;
    color: #2c1d1a;
    line-height: 24px;
    -webkit-background-clip: text;
    font-family: Poppins-Regular, Poppins;
  }
  }
  .login-input {
    input {
      width: 340px;
      height: 40px;
      background: #ffffff;
      opacity: 1;
      border: 2px solid #4573e7;
      display: inline-block;
      font-size: 14px;
      font-family: Poppins-Regular, Poppins;
      font-weight: 400;
      color: #bfc1cc;
      line-height: 16px;
      padding: 0 0 0 8px;
      -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    }
    .login-input1 {
      margin-top: 50px;
    }

    .login-input2 {
      margin: 25px 0;
    }
  }
  .login-input3 {
  span {
    display: inline-block;
    float: left;
  input {
    width: 245px;
    height: 40px;
    background: #ffffff;
    opacity: 1;
    border: 1px solid #c5d0de;
    font-size: 14px;
    font-family: Poppins-Regular, Poppins;
    font-weight: 400;
    color: #bfc1cc;
    line-height: 16px;
    -webkit-background-clip: text;
    padding: 0 0 0 8px;
  }
  }
  span:nth-child(2) {
    width: 85px;
    height: 40px;
  /*// border-radius: 0px 0px 0px 0px;*/
    opacity: 1;
    background-color: #000;
    margin: 1px 0 0 10px;
  }
  }
  .Login-btn-buttom {
    margin-top: 25px;
  p {
    font-size: 14px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #4573e7;
    line-height: 24px;
    -webkit-background-clip: text;
  }

  div:nth-child(1) {
    float: left;
  }
  div:nth-child(2) {
    float: right;
  }
  }

  p{
    font-size: 12px;
    font-family: Poppins-Regular, Poppins;
    font-weight: 400;
    color: #E10475;
    line-height: 14px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 0 !important;
  }
  .el-form-item:nth-child(1) {
    margin: 50px 0 20px 0;
  }
  .el-form-item:nth-child(3) {
    margin: 20px 0 0 0;
    /*width: 245px;*/
    height: 40px;
  }
  .el-form-item:nth-child(4) {
    margin: 20px 0 20px 0;
    /*width: 245px;*/
    height: 40px;
  }
  .el-form-item {
    position: relative !important;
    p{
      font-size: 14px;
      font-family: Poppins-Bold, Poppins;
      font-weight: bold;
      color: #2C1D1A;
      line-height: 16px;
      margin-bottom: 10px;
    }
  }

  .el-btn1 {
    width: 199px !important;
    height: 20px !important;
    font-family: Poppins-Regular, Poppins;
    font-weight: 400;
    font-size: 12px;
    color: #E10475 !important;
    line-height: 14px;
    border-radius: 0;
    background-color: #fff !important;
    border: none;
    border-left: 1px solid #c5d0de;
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 1;
    padding: 0 15px;
  }
  .el-btn2 {
    width: 350px;
    height: 40px;
    background: #4573e7;
    border-radius: 5px;
    opacity: 1;
    border: 1px solid #c5d0de;
    margin-top: 25px;
    font-size: 14px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }
  }
  }
  }
</style>
